/**
 * The Price Simulator route (FSD 5.2.3 "Simulate Price").
 *
 * Spread into `PRICING_ROUTES` (pricing/routes.ts), so the shared router needs no
 * edit. The path is a literal string: the conformance deep-link parser reads route
 * records as text and cannot follow a helper call.
 *
 * Gated on `pricing.price.read`, the permission `GET /pricing/resolve` declares —
 * the simulator prices nothing and writes nothing, so a read code is the honest gate.
 */

import type { RouteRecordRaw } from 'vue-router'

import { PRICING_PERMISSIONS } from '@/modules/pricing/permissions'

export const PRICING_SIMULATOR_ROUTES: RouteRecordRaw[] = [
  {
    path: '/pricing/simulate',
    name: 'pricing-simulator',
    component: () => import('@/modules/pricing/simulator/PriceSimulatorView.vue'),
    meta: {
      titleKey: 'pricing.u62.simulator.title',
      permission: PRICING_PERMISSIONS.priceRead,
    },
  },
]
